import { Component, OnInit } from '@angular/core';
import { MOCK_TIPS_PREVIEWS, TipPreview } from '../mock-data/mock-sports.data';

@Component({
  selector: 'app-tips-and-previews',
  templateUrl: './tips-and-previews.component.html',
  styleUrls: ['./tips-and-previews.component.scss'],
})
export class TipsAndPreviewsComponent implements OnInit {
  tipsPreviews: TipPreview[] = MOCK_TIPS_PREVIEWS;

  ngOnInit(): void {}
}
